import { Config } from "./types";

const config: Config = {
    //dashboardUrl: "https://dashboard-dev.fitforwork.ai",
    dashboardSubdomain: "dashboard-dev",
};

export default config;
